// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__nZMZF","consentsList":"PatientConsents_consentsList__LweYb","consentsListEmpty":"PatientConsents_consentsListEmpty__1kSxi"};